<script setup lang="ts">
import NoDataContent from '@/common/components/molecules/noData/NoDataContent.vue';
import IconDecoLine from '@/common/components/molecules/iconDecoLine/IconDecoLine.vue';

import { useInternational } from '@/common/locale';
import { type IconType } from '@/types/icon.types';

const props = withDefaults(defineProps<{ message?: string; icon?: IconType }>(), {
  icon: 'icon-warning',
});

const { t } = useInternational();
</script>

<template>
  <div class="menu-search-error">
    <no-data-content>
      <template #icon>
        <icon-deco-line>
          <ev-icon :icon="props.icon" />
        </icon-deco-line>
      </template>
      <template #message>
        {{ props.message ?? t('MESSAGE.GNB_SEARCH_DEFAULT_ERROR_MESSAGE') }}
      </template>
    </no-data-content>
  </div>
</template>

<style scoped lang="scss">
.menu-search-error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 140px;
  background-color: var(--color-gray-07-01);

  :deep(.no-data-content__message) {
    color: var(--color-gray-02-10);
  }
}
</style>
